import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../../Styles/Common.module.css';
import Button from '../../Styles/Button.module.css';
import { Link } from "react-router-dom";
import { IoArrowForwardCircleOutline } from "react-icons/io5";

const BusinessDirectoryPage= ()=>{
    
    const smoothScroll = () => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      };
    return(
        <div className={Style.businessPage}>
           <section className={Style.clear + " "+Style.breadcrumb}>
                <Container>
                <Row>
                    <Col>
                        <ul>
                            <li><Link to="/">Home </Link></li>
                            <li><Link to='/community'>Community</Link></li>
                            <li>Business Directory</li>
                        </ul>
                    </Col>
                </Row>
                </Container>
            </section>
            <div className={Style.pageTitle + ' ' + Style.marginUp90}>
                <Container>
                    <Row>
                        <Col>
                            <div className={Style.sectionTitle}>
                                <h2>Business Directory</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row className={Style.twoColSpace}>
                        <Col md={6}>
                            <div className={Style.communityContainer}>
                                <figure>
                                    <img src={require('../../../assest/images/community-img02.png')} />
                                </figure>
                                <div className={Style.communitelement}>
                                    <img src={require('../../../assest/images/business-listinr-icon01.png')} />
                                    <h3><Link to='/view-business-listing' >VIEW BUSINESS LISTING</Link></h3>
                                    <p>Search Alumni Business Directory & Connect With Mayo Alumni Business Community</p>
                                    <Link to='/view-business-listing' className={Button.goGreenBtn + ' ' + Style.communityLink}><IoArrowForwardCircleOutline /></Link>
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className={Style.communityContainer}>
                                <figure>
                                    <img src={require('../../../assest/images/business-directory-img02.png')} />
                                </figure>
                                <div className={Style.communitelement}>
                                    <img src={require('../../../assest/images/business-listinr-icon02.png')} />
                                    <h3><Link to='/'>LIST YOUR BUSINESS</Link></h3>
                                    <p>Register Your Business For Listing In The Mayo Alumni Business Directory</p>
                                    <Link to='/business-directory-create' className={Button.goGreenBtn + ' ' + Style.communityLink}><IoArrowForwardCircleOutline /></Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default BusinessDirectoryPage;